///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/ym-membership.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class YMMembershipsDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected memberships: YMMembershipsCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.memberships;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.filters = [new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_MEMBERSHIPS'}, this, false)];

            this.memberships = new YMMembershipsCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                defaultValue: <ModelValueType[]>options.defaultValue,
                smartMoverHidden: () => this.smartMoverHidden,
            });

            this.memberships.addFilters(...this.filters as IInteractiveFilter[]);

            if (options.required) {
                this.validation.push(new RequiredValidation(this.collection, 'LABEL_MEMBERSHIP_REQUIRED'));
            }

            this.title = 'LABEL_MEMBERSHIPS';
            this.allSelectedLabel = 'LABEL_ALL_MEMBERSHIPS';
            this.totalSelectedMessage = 'LABEL_TOTAL_MEMBERSHIPS_SELECTED';
        }
    }
}
